// import moment from 'moment';
import { addSeconds, format } from 'date-fns';
import { Auction } from '../app-modules/buyer/buyer-modules/buyer-auctions/_interfaces/auction.interface';
import { IPagination } from '../Shared/_models/pagination.model';
import { toZonedTime } from 'date-fns-tz';
//TODO Remove this when handle in all places
export function changeAuctionStatus(
  auction_id: number,
  accepted: boolean,
  auctions: any[]
) {
  const copyAuctions = [...auctions];
  const index = copyAuctions.findIndex((el) => el?.id == auction_id);
  if (index != -1) {
    if (accepted) {
      //in case accepted
      copyAuctions[index].request_to_join_status = true;
      copyAuctions[index].auction_buyer_last_record = true;
    } else {
      //rejected

      copyAuctions[index].request_to_join_status = false;
      copyAuctions[index].auction_buyer_last_record = false;
    }
  }
  return [...copyAuctions];
}

export function changeAuctionsStatuses(
  auction_ids: number[],
  accepted: boolean,
  auctions: any[]
) {
  const copyAuctions = [...auctions];

  auction_ids.forEach((auction_id) => {
    const index = copyAuctions.findIndex((el) => el?.id == auction_id);
    if (index !== -1) {
      copyAuctions[index].request_to_join_status = accepted;
      copyAuctions[index].auction_buyer_last_record = accepted;
    }
  });

  return [...copyAuctions];
}
export function changeAuctionItemStatus(accepted: boolean, auction: any) {
  const copyAuction = auction;
  if (accepted) {
    //in case accepted
    copyAuction.request_to_join_status = true;
    copyAuction.auction_buyer_last_record = true;
  } else {
    //rejected

    copyAuction.request_to_join_status = false;
    copyAuction.auction_buyer_last_record = false;
  }

  return copyAuction;
}

export function getAuctionsData(
  response: {
    data: { items: Auction[]; pagination: IPagination };
    current_datetime: Date;
  },
  serverTime = 0
) {
  return response.data.items.map((el) => {
    const {
      accepted_invited_buyer,
      auction_buyer_last_record,
      end_date,
      ended,
      extended_end_date,
      highest_bid_amount,
      highest_bid_amount_not_winning_items,

      invited_buyer,

      latest_bid_time,
      request_to_join,
      request_to_join_status,
      running,
      updated_end_date_time,
    } = el.auction_settings!;

    const data = { ...el };
    delete data.auction_settings;
    return {
      ...data,
      accepted_invited_buyer,
      auction_buyer_last_record,
      end_date,
      ended,
      // extended_end_date,
      highest_bid_amount,
      highest_bid_amount_not_winning_items,

      invited_buyer,

      latest_bid_time,
      request_to_join,
      request_to_join_status,
      running,

      current_date: format(
        addSeconds(response.current_datetime, serverTime), // Add server time to the current datetime
        'yyyy-MM-dd HH:mm:ss' // Format it in 'YYYY-MM-DD HH:mm:ss'
      ),
    };
  });
}
export function getAuctionType(running: boolean, ended: boolean) {
  let auctionType: string;
  if (running && !ended) {
    auctionType = 'active';
  } else if (!running && ended) {
    auctionType = 'previous';
  } else if (!running && !ended) {
    auctionType = 'upcoming';
  } else {
    auctionType = 'previous';
  }
}

export function getEndingOfAuction(
  currentDateStr: any,
  auction_end_date: any
): boolean {
  const auctionEndDate = new Date(auction_end_date);
  const currentDate = new Date(currentDateStr);
  if (currentDate > auctionEndDate) {
    return true;
  } else {
    return false;
  }
}
export function getEndingOfAuctionRealTimeCheck(
  auction_end_date: any,
  currentDateStr: any,
  callback: (ended: boolean) => void
): number {
  const auctionEndTime = new Date(auction_end_date).getTime();
  const initialCurrentTime = new Date(currentDateStr).getTime();
  callback(initialCurrentTime >= auctionEndTime);

  const intervalId = window.setInterval(() => {
    const now = toZonedTime(new Date(), 'UTC').getTime();
    callback(now >= auctionEndTime);
  }, 1000);

  return intervalId;
}
